import { AxiosResponse } from 'axios';

import { LoginData } from './dto/Auth';
import {
  InitRegistrationRequest,
  RegistrationResponse,
} from './dto/Registration';
import { AuthApi } from './BaseApi';

const authApi = {
  passwordLogin(
    phoneNumber: string,
    password: string
  ): Promise<AxiosResponse<LoginData>> {
    const payload = {
      phoneNumber,
      password,
    };
    return AuthApi.post(`/api/auth/v1/login`, payload);
  },
  login(id: string, code: string): Promise<AxiosResponse<{ jwt: string }>> {
    const payload = {
      code,
      verificationCodeId: id,
    };
    return AuthApi.post(`/api/auth/v1/authorization`, payload);
  },
  registration(
    payload: InitRegistrationRequest
  ): Promise<AxiosResponse<RegistrationResponse>> {
    return AuthApi.post('/api/auth/v1/registration', payload);
  },
  refreshToken(token: string): Promise<AxiosResponse<{ jwt: string }>> {
    return AuthApi.get('/api/auth/v1/refresh', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};

export default authApi;
